<template>
	<v-popover
		:popover-base-class="classes"
		:popover-class="popover_classes"
		:trigger="trigger"
		:offset="offset"
		:placement="placement"
		ref="popover"
		:auto-hide="autoHide"
		:delay="{ show: 0, hide: 50 }"
	>
		<slot name="icon">
			<button
				class="icon-button size-input icon-size-medium popover-button"
				:class="{ 'button-height': besidesButton }"
				type="button"
			>
				<svg class="icon" width="20" height="20" v-show="can_display">
					<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#dots"></use>
				</svg>
			</button>
		</slot>

		<slot slot="popover"></slot>
	</v-popover>
</template>

<script type="text/babel">
export default {
	props: {
		placement: { default: "bottom" },
		theme: { default: "dark" },
		type: { default: "list" },
		trigger: { default: "hover focus click" },
		besidesButton: { default: false },
		autoHide: { default: false },
		preload: { default: true },
		offset: { default: -5 },
	},

	data: function () {
		return {
			can_display: false,
		};
	},

	computed: {
		popover_classes() {
			let classes = "";

			if (!this.can_display) {
				classes += "hidden";
			}

			return classes;
		},

		classes() {
			let classes = "tooltip popover, v-popover-icon-dropdown vue-popover-theme";

			classes += " " + this.theme;
			classes += " " + this.type;

			return classes;
		},
	},

	mounted() {
		if (this.preload) {
			// Gross hack implemented to avoid lag etc
			if (this.$refs.popover) {
				this.$refs.popover.show();
			}

			let init_interval = setInterval(() => {
				if (this.$refs.popover && this.$refs.popover.isOpen) {
					clearInterval(init_interval);
					this.$refs.popover.hide();

					setTimeout(() => {
						this.can_display = true;
					}, 10);
				}
			}, 10);
		} else {
			this.can_display = true;
		}
	},
};
</script>

<style lang="scss">
.tooltip.popover.hidden {
	display: none !important;
	visibility: hidden !important;
	opacity: 0 !important;
}

.tooltip-inner .icon-button {
	color: #ddd;
	padding: 4px !important;
	margin: 0 !important;
	width: 28px !important;

	&:hover,
	&:focus {
		color: #fff;
	}
}

ul.submenu {
	list-style: none;
	margin: 0;
	padding: 0;

	li a {
		color: #0c0a1c;
		display: block;
		padding: 5px 18px;

		&:hover,
		&:focus {
			color: #07070e;
			background: rgba(0, 0, 0, 0.04);
		}
	}
}
</style>
